import React, { useState, useContext } from 'react';
import '@progress/kendo-ui'
import '@progress/kendo-theme-default/dist/all.css'
import validate from '../Validation/Validation'
import { ConfigurationContext } from '../../Context/Configuration';
import constant from '../../Constants/constants'
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Input, Checkbox, MaskedTextBox } from '@progress/kendo-react-inputs';
import Confirmation from '../Quiz/Confirmation';
import axios from 'axios';
import '../Notification/FormTemplate.css'
import UseForm from '../Notification/UseForm'



const FormTemplate = () => {

    const [config,update] = useContext(ConfigurationContext);
    const [disableSubmit, setDisableSubmit] = useState(false)
    const [confirmation,setConfirmation] = useState(false)

    const [formData, setFormData] = useState({
        firstName: config.formData.firstName,
        lastName: config.formData.lastName,
        businessName: config.formData.farmName,
        address1: config.formData.address1,
        address2: config.formData.address2,
        city: config.formData.city,
        province: config.formData.province,
        postalCode: config.formData.postalCode,
        email: config.formData.email,
        phone: config.formData.phone,
        contactCode:config.formData.contactCode,
        acceptTAndC: false,
        acceptCEM: false,
        campaignId: 4,
        source:'Contest Website'
    });

    const customValidations = {notification: false, cem: false}

    const submit = () => {

      
        var contestData = { ...formData }
        contestData.postalCode = contestData.postalCode.replace(/\s/g, '')
      
        if(disableSubmit == false)
        {
        setDisableSubmit(true);
        axios({
            method: 'post',
            url: `${constant.server_url}/preseedherbicide/api/contests/insert`,
            data: { data: JSON.stringify(contestData) }

        }).then(function (response) {
            if (response.data.success) {
                setDisableSubmit(false);
                setConfirmation(true);
                
              }
        })
            .catch(function (response) {
                setDisableSubmit(false);
                console.log("error");
                
            });
        }
    }

    const { handleChange, handleSubmit,handleBlur, errors, consentData, acceptCEM, provinces, acceptTAndC,contactMe } = UseForm({ submit, validate, formData, setFormData, setDisableSubmit, customValidations });

    return (
        <React.Fragment>
            <div className="formTextFormat" style={{display:!confirmation?"block":"none"}}>

                <Form
                    render={() => (
                        <FormElement>
                            <fieldset className={'k-form-fieldset'}>
                                <legend><h3>Basic Information</h3></legend>

                                <div className="gridContainer">
                                    <div className="inputDiv"  style={{msGridColumn:1, msGridRow:1}}>
                                        <Field className={`${errors.firstName && "inputError"}`} value={formData.firstName} id={'firstName'} name={'firstName'} component={Input} label={'First Name'} onBlur={handleBlur} onChange={handleChange} />
                                        {/* {errors.firstName && <p className="errorText">{errors.firstName}</p>} */}
                                        <p className="errorText">Required</p>
                                    </div>
                                    <div className="inputDiv"  style={{msGridColumn:2, msGridRow:1}}>
                                        <Field className={`${errors.lastName && "inputError"}`} value={formData.lastName} id={'lastName'} name={'lastName'} component={Input} label={'Last Name'} onBlur={handleBlur} onChange={handleChange} />
                                        {/* {errors.lastName && <p className="errorText">{errors.lastName}</p>} */}
                                        <p className="errorText">Required</p>
                                    </div>
                                    <div className="inputDiv"  style={{msGridColumn:3, msGridRow:1}}>
                                        <Field value={formData.businessName} id={'businessName'} name={"businessName"} component={Input} label={"Farm Name"} onBlur={handleBlur} onChange={handleChange} />
                                        <p className="errorText">Required</p>
                                    </div>

                                    <div className="inputDiv"  style={{msGridColumn:1, msGridRow:2}}>
                                        <Field className={`${errors.address1 && "inputError"}`} value={formData.address1} id={'address1'} name={'address1'} component={Input} label={'Address Line 1'} onBlur={handleBlur} onChange={handleChange} />
                                        {/* {errors.address && <p className="errorText">{errors.address}</p>} */}
                                        <p className="errorText">Required</p>
                                    </div>
                                    <div className="inputDiv"  style={{msGridColumn:2, msGridRow:2}}>
                                        <Field value={formData.address2} id={'address2'} name={'address2'} component={Input} label={'Address Line 2'}  onChange={handleChange} />
                                        
                                    </div>
                                    <div className="inputDiv"  style={{msGridColumn:3, msGridRow:2}}>
                                        <Field className={`${errors.city && "inputError"}`} value={formData.city} id={'city'} name={'city'} component={Input} label={'City'} onBlur={handleBlur} onChange={handleChange} />
                                        {/* {errors.city && <p className="errorText">{errors.city}</p>} */}
                                        <p className="errorText">Required</p>
                                    </div>
                                    <div className="inputDiv"  style={{msGridColumn:1, msGridRow:3}}>
                                        <Field className={`${errors.postalCode && "inputError"}`}  maxLength={7} value={formData.postalCode} id={'postalCode'} name={'postalCode'} onBlur={handleBlur} component={Input} label={'Postal Code'} onChange={handleChange} />
                                        {/* {errors.postalCode && <p className="errorText">{errors.postalCode}</p>} */}
                                        <p className="errorText">Required</p>
                                    </div>
                                    {/* <div className="inputDiv"  style={{msGridColumn:2, msGridRow:3}}>
                                        <DropDownList className={`${errors.province && "inputError"}`} defaultItem={provinces[formData.province]} id={'province'} name={'province'} label={'Province'} data={provinces}
                                            textField="text"
                                            dataItemKey="id"
                                            inputtype={'select'}
                                            onChange={handleChange}
                                        />
                                        {errors.province && <p className="errorText">{errors.province}</p>}
                                    </div> */}

                                
                                    <div className="inputDiv"  style={{msGridColumn:3, msGridRow:3}}>
                                        <Field className={`${errors.email && "inputError"}`} id={'email'} name={'email'} value={formData.email} component={Input} label={'Email'} onBlur={handleBlur} onChange={handleChange} />
                                        {/* {errors.email && <p className="errorText">{errors.email}</p>} */}
                                        <p className="errorText">Required</p>
                                    </div>
                                    <div className="inputDiv"  style={{msGridColumn:1, msGridRow:4}}>
                                        <MaskedTextBox mask="(000) 000-0000" className={`${errors.phone && "inputError"}`} id={'phone'} name={"phone"}  component={Input} onBlur={handleBlur} label={"Mobile Phone"} onChange={handleChange} />
                                        {/* {errors.phone && <p className="errorText">{errors.phone}</p>} */}
                                        <p className="errorText">Required</p>
                                    </div>
                                </div>
                                
                                <div className="checkBoxGroup">
                                    <div style={{msGridColumn:2, msGridRow:1, marginTop:'25px'}}>
                                        <Checkbox className={`${errors.acceptTAndC && "inputError"} inputDiv chk_Contest`} checked={(formData.acceptTAndC ? true : false)} name={acceptTAndC.name} id={acceptTAndC.name} label={<React.Fragment> I have read and agreed to <a className={'acceptLink'} href={'/preseedherbicide/assets/Pre-Seed_FeelTheBurn_TCs.pdf'} target="_blank" rel="noopener noreferrer"> Terms and Conditions  </a> </React.Fragment>} onChange={handleChange} />
                                        {/* {errors.acceptTAndC && <p className="errorText">{errors.acceptTAndC}</p>} */}
                                    </div>
                                    <div>
                                        <Checkbox checked={(formData.acceptCEM ? true : false)} className={`${errors.acceptCEM && "inputError"} inputDiv chk_Contest`} name={acceptCEM.name} label={<React.Fragment>I have read and agreed to provide <a className={'acceptLink'} href={'/preseedherbicide/assets/cemconsent.pdf'} target="_blank" rel="noopener noreferrer"> Commercial Electronic Message Consent </a></React.Fragment>} onChange={handleChange} />
                                        {errors.acceptCEM && <p className="errorText">{errors.acceptCEM}</p>}
                                    </div>
                                

                                </div>
                            </fieldset>
                            <button
                                type={'submit'}
                                disabled={disableSubmit}
                                className="red_button"
                                onClick={handleSubmit}
                            >
                                Submit
                            </button>
                        </FormElement>
                    )}
                />
            </div>
            <div className="confirmation" style={{display:confirmation?"block":"none"}}>
                <Confirmation></Confirmation>
            </div>
        </React.Fragment>
    );
}

export default FormTemplate;

